import { Link } from "react-router-dom";
import { PHILOSOPHY_SCHOOLS, PRAMANAS, IMAGES } from "@/data/content";
import { Reveal, Eyebrow, SectionTitle } from "@/components/common";

export default function Philosophy() {
  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="philosophy-page">
      <section className="relative py-24 lg:py-32 border-b border-indic-gold/15">
        <img src={IMAGES.templeCarved} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1021]/75 to-indic-indigo" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-8">
          <Eyebrow>Philosophical Traditions</Eyebrow>
          <h1 className="mt-4 font-serif text-5xl lg:text-7xl font-semibold text-amber-50 max-w-3xl leading-[1.05]">The great schools of Indic thought</h1>
          <p className="mt-6 max-w-2xl text-lg text-slate-300/90 leading-relaxed">
            For over two millennia, Indic philosophers argued — with extraordinary rigour — about reality, mind, language, and the means of valid knowledge. These are the arguments, not merely the labels.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Reveal><SectionTitle eyebrow="The Darshanas & Beyond" title="Eight systems of inquiry" /></Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
            {PHILOSOPHY_SCHOOLS.map((s, i) => (
              <Reveal key={s.name} delay={(i % 2) * 0.06}>
                <div className="group rounded-sm border border-indic-card-border bg-indic-card p-6 hover:border-indic-gold/40 transition-colors" data-testid={`school-${i}`}>
                  <div className="flex items-baseline justify-between">
                    <h3 className="font-serif text-2xl text-amber-50">{s.name}</h3>
                    <span className="text-xs font-sans uppercase tracking-wider text-indic-gold/80">{s.gloss}</span>
                  </div>
                  <p className="mt-3 text-sm text-slate-300/85 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-[#080c1a] border-y border-indic-card-border">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Reveal><SectionTitle eyebrow="Pramana" title="How do we know?" subtitle="The classical means of valid knowledge — a shared obsession of Indic epistemology." /></Reveal>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {PRAMANAS.map((p, i) => (
              <Reveal key={p.name} delay={i * 0.05}>
                <div className="rounded-sm border border-indic-gold/20 bg-indic-indigo p-5 text-center h-full">
                  <div className="font-serif text-xl text-indic-gold">{p.name}</div>
                  <div className="mt-1 text-xs text-slate-400">{p.en}</div>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Link to="/library/holy-book" className="inline-flex items-center rounded-sm border border-indic-gold/50 px-6 py-3 font-semibold text-amber-50 hover:bg-indic-gold/10 transition-colors" data-testid="philosophy-read-link">Read on knowing, in The Holy Book →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
